import type { PropsWithChildren } from 'react';

type BlogArticleInlineImageContentProps = PropsWithChildren;

export const BlogArticleInlineImageContent = ( { children }: BlogArticleInlineImageContentProps ) => {

  return (
    <div className={ 'absolute bottom-0 inset-x-0 p-3 flex flex-col gap-3.5 backdrop-blur-[22px] md:backdrop-blur-[44px] border-t border-t-white/30 rounded-b-[18px] group-data-[variant="light"]:bg-white/20' }>
      { children }
    </div>
  )
}
BlogArticleInlineImageContent.displayName = 'BlogArticleInlineImageContent';
